/* eslint-disable no-underscore-dangle */
import { useCallback, useEffect, useRef } from 'react'
import { useBreakpoint } from './useBreakpoint'
import { useScrollLock } from './useScrollLock'

export const useChatOpen = () => {
  const { isMobile } = useBreakpoint()
  const { lock, unlock } = useScrollLock()
  const chatObserverRef = useRef<MutationObserver | null>(null)

  useEffect(() => () => chatObserverRef.current?.disconnect(), [])

  const openChat = useCallback(() => {
    window?._upservice?.setState({ isOpen: true })
    chatObserverRef.current?.disconnect()

    if (!isMobile) return

    const widget = document.querySelector('ups[data-widget-component="layout"]')

    if (!widget) return

    lock()
    chatObserverRef.current = new MutationObserver(() => {
      if (widget.className.includes('open')) return
      unlock()
      chatObserverRef.current?.disconnect()
    })
    chatObserverRef.current.observe(widget, { attributes: true, attributeFilter: ['class'] })
  }, [isMobile, lock, unlock])

  return { openChat }
}
